import type { CreateTaskApiRequest, TaskListItemApi, UpdateTaskApiRequest } from '@/types/api/tasks';

/**
 * Demo-mode fabricated response for creating a task.
 * Used as the demoFn for useCreateTaskMutation.
 */
export function createTaskDemoResponse(data: CreateTaskApiRequest): TaskListItemApi {
  const now = new Date().toISOString();
  return {
    taskId: Date.now(),
    title: data.title,
    description: data.description ?? null,
    taskType: data.taskType ?? 'Task',
    taskTypeName: data.taskType ?? 'Task',
    status: 'Open',
    statusName: 'Open',
    dueDate: data.dueDate,
    priority: null,
    userAssignedId: data.userAssignedId,
    assignedUserName: 'Demo User',
    customerId: data.customerId ?? null,
    customerName: null,
    customerAccountNumber: null,
    linkId: data.transactionId ?? null,
    linkType: data.transactionId ? 'Transaction' : null,
    transactionReference: null,
    createdByUserId: 0,
    createdByName: 'Demo User',
    createdAt: now,
    updatedAt: now,
    completedAt: null,
    completedByUserId: null,
    completedByName: null,
    daysOverdue: null,
  };
}

/**
 * Demo-mode fabricated response for updating a task.
 * Used as the demoFn for useUpdateTaskMutation.
 */
export function updateTaskDemoResponse({
  taskId,
  data,
}: {
  taskId: number;
  data: UpdateTaskApiRequest;
}): TaskListItemApi {
  const now = new Date().toISOString();
  return {
    taskId,
    title: data.title,
    description: data.description ?? null,
    taskType: 'Task',
    taskTypeName: 'Task',
    status: 'Open',
    statusName: 'Open',
    dueDate: data.dueDate,
    priority: null,
    userAssignedId: data.userAssignedId,
    assignedUserName: 'Demo User',
    customerId: data.customerId ?? null,
    customerName: null,
    customerAccountNumber: null,
    linkId: null,
    linkType: null,
    transactionReference: null,
    createdByUserId: 0,
    createdByName: 'Demo User',
    createdAt: now,
    updatedAt: now,
    completedAt: null,
    completedByUserId: null,
    completedByName: null,
    daysOverdue: null,
  };
}

/**
 * Demo-mode fabricated response for completing a task.
 * Used as the demoFn for useCompleteTaskMutation.
 */
export function completeTaskDemoResponse(taskId: number): TaskListItemApi {
  const now = new Date().toISOString();
  return {
    taskId,
    title: 'Demo Task',
    description: null,
    taskType: 'Task',
    taskTypeName: 'Task',
    status: 'Completed',
    statusName: 'Completed',
    dueDate: now,
    priority: null,
    userAssignedId: 0,
    assignedUserName: 'Demo User',
    customerId: null,
    customerName: null,
    customerAccountNumber: null,
    linkId: null,
    linkType: null,
    transactionReference: null,
    createdByUserId: 0,
    createdByName: 'Demo User',
    createdAt: now,
    updatedAt: now,
    completedAt: now,
    completedByUserId: 0,
    completedByName: 'Demo User',
    daysOverdue: null,
  };
}
